import React, { useState, useRef, useEffect, useCallback } from "react";
import { default as pdfFileApi } from './../../common/serviceApi';
import { jsPDF } from "jspdf";
import mmlogo from '../../assets/images/pdfAssets/mmlogo_merl.png';
import mm_template_img from '../../assets/images/pdfAssets/mmlogo_merl_2.png';
import salary_guide_btn from '../../assets/images/pdfAssets/mmlogo_merl_btn.png';
import { useAuth } from "../../auth/AutoContextProvider";
import { useCommon } from "../CommonServiceProvider";
import { rejectedDomains } from "./defaults";
import { isEmailValid, combineNames } from "../../util/string-helper";

const JsPDFExporter = ({ text, role, disabled, formData , uId, onClick, emailStatus, setEmailStatus }) => {
    const [_, {sso, getCookie, getFinalGuestToken}]= useAuth()
    const [{sendEmail, refreshLimitToken, sendToHubspot }]= useCommon()
    const [generatedPdfBlob, setGeneratedPdfBlob] = useState(null);
    const [hoveredBuildMii, setHoveredBuildMii] = useState(false);
    const [loading, setLoading] = useState(false);
    const refresh = getCookie('tkn-ath-rfrsh')
  
    // load mmlogo
    const getImageDataURL = (imgPath) => {
        return new Promise((resolve, reject) => {
        var img = new Image();
        img.src = imgPath;
        img.onload = function () {
            let canvas = document.createElement('canvas');
            canvas.width = this.width;
            canvas.height = this.height;
            let ctx = canvas.getContext('2d');
            ctx.drawImage(this, 0, 0);
            let dataURL = canvas.toDataURL('image/png');
            resolve(dataURL);
        };
        img.onerror = function () {
            reject(new Error('Could not load image'));
        };
        });
    };

    // export to PDF. The "handlePDF" function contains all codes to generate the PDF and save.
    // install the jsPDF package and import to access parameters used.
    const handlePDF = async (jdResponse) => {

        //load the template images as a Data URL
        let mmlogoDataURL= await getImageDataURL(mmlogo); //multiplymii logo in header
        let mm_template_img_DataURL = await getImageDataURL(mm_template_img); //template image in right header
        let salary_guide_btn_DataURL = await getImageDataURL(salary_guide_btn); //salary guide button in footer
        // Add static text next to the mmlogo
        const textX = 68;  // X-coordinate for the text
        const textY = 16;  // Y-coordinate for the text
        const headerText1 = "Recruiting the top 5% of the Filipino Talent.";
        const headerText2 = "Here's How.";
        const doc = new jsPDF("portrait", "mm", "a4"); //set pdf orientation and size
        let defaultFont = "helvetica";
        doc.setFont(defaultFont); // Setting default font to Helvetica
        doc.setFontSize(12); // Setting default font size to 12 points
        let splitText = doc.splitTextToSize(jdResponse, 190);
        let pageHeight = 297;  // A4 height in mm
        let pageWidth = 210;  // A4 width in mm
        let lineHeight = 6;  // Line height in mm
        let margin = 10;  // Page margin in mm
        let cursorY = 40;  // Initial Y
        for(let i = 0; i < splitText.length; i++) {
          if (cursorY > (pageHeight - margin - 20)) { // Check for page overflow
            doc.addPage();
            cursorY = 40;  // Reset cursorY for new page
          }
          // Check if the line starts with "Role", "Job Description", "Responsibilities", "Results" or "Resquirements" and setFont & setFontSize
          if (splitText[i].startsWith("Role:") || 
              splitText[i].startsWith("Job Description") || 
              splitText[i].startsWith("Responsibilities:") ||
              splitText[i].startsWith("Results:") ||
              splitText[i].startsWith("Requirements:") ||
              splitText[i].startsWith("Salary Guide:") ||
              splitText[i].startsWith("Key interview questions:")
              ) {
            doc.setFont(defaultFont, "bold"); //if heading, change the font properties
            doc.setFontSize(14);
            doc.setTextColor(66,153,225);
          } else {
            doc.setFont(defaultFont, "normal");
            doc.setFontSize(12);
            doc.setTextColor(106,119,138);
          }
          // Replace dash with bullet point if the line starts with a dash
          if (splitText[i].startsWith("-")) {
            splitText[i] = splitText[i].replace("-", "•");
          }
          doc.text(splitText[i], 10, cursorY);
          cursorY += lineHeight; // Move cursor down by lineHeight
        }
        // Add repeating text/images/page numbers on every page.
        const pageCount = doc.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          const pageNumberText = `Page ${i} of ${pageCount}`;
          const textWidth = doc.getTextWidth(pageNumberText);
          doc.setFontSize(9);
          doc.text(pageNumberText, pageWidth - margin - textWidth, pageHeight - margin);
          //add the text, images and links to the PDF header
          const logoUrl = "https://multiplymii.com"; //link of the MM logo
          doc.addImage(mmlogoDataURL, "PNG", 10, 10, 55, 10) //add MM logo
          doc.link(10, 10, 55, 10, { url: logoUrl }); //set the link area of MM logo
          doc.addImage(mm_template_img_DataURL, 'PNG', 160, 0, 55, 20); //add the template header image
          //Set the text properties of "Recruiting the top 5% of the Filipino Talent." in header
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(106,119,138);
          doc.text(headerText1, textX, textY);
          //Set the text properties and link of "Here's How." in header
          doc.setTextColor(66,153,225);
          doc.setFont("helvetica", "italic");
          doc.text(headerText2, textX+55, textY);
          const linkUrl = "https://www.multiplymii.com/start-hiring";
          const linkTextWidth1 = doc.getTextWidth(headerText2);
          doc.link(textX+55, textY - 4, linkTextWidth1, 4, { url: linkUrl }); //set link area
          //add the text, images and links to the PDF footer
          doc.setTextColor(106,119,138);
          doc.setFont("helvetica", "normal");
          const footerUrl = "https://multiplymii.com/salary-guide"; //set the link of the "Download Salary Guide" button
          const footerText = "Discover how much this role costs (+ the 50 most in-demand roles).";
          const x = 10;
          const y = pageHeight - margin;
          doc.text(footerText, x, y); //add the text "Discover how much this role costs (+ the 50 most in-demand roles)."
          // Add the salary_guide_btn image beside the footer text
          const imgWidth = 45; // image width
          const imgHeight = 6; // image height
          const imgX = x + doc.getTextWidth(footerText) + 1; //x-position of footer button
          const imgY = y - 4; //y-position of footer button
          doc.addImage(salary_guide_btn_DataURL, 'PNG', imgX, imgY, imgWidth, imgHeight); //add the footer button
          doc.link(x + 85, y - 10, imgWidth, 12, {url: footerUrl}); //set the button link
        }
      

        const blob = doc.output('blob');
        return  blob
        // setGeneratedPdfBlob(blob);
    };

    const savePdf = useCallback(async(blob,role,uId) => {
        setLoading(true)
        const fileObj = new Promise((resolve, reject) => {
          const key = `job-description-templates/${uId}/job-description-${role}`
          refreshLimitToken(refresh)
          .then((response) =>{
            const fetchFile = pdfFileApi.get(`s3/signed-url?key=${key}&expires=500&type=pdf`)
            .then((response) => {
    
              if (response?.headers['rate-limit-token'] && response?.headers['rate-limit-refresh-token']) {
                sso(response?.headers['rate-limit-token'], response?.headers['rate-limit-refresh-token']);
              }
              return fetch(response?.data?.signedUrl, {
                method: 'PUT',
                headers: {
                  'Content-Type': blob?.type
                },
                body: blob,
              }).then(() => {
                return {
                  name: `${role}-job-description.pdf`,
                  size: blob?.size,
                  awsFilePath: response?.data?.publicUrl
                }
              })
              .catch(error => {
                console.log("error",error)
                setLoading(false)
                refreshLimitToken(refresh)
                reject(error);
              })
            })
            .catch(error=>{
              console.log("error",error)
              setLoading(false)
              refreshLimitToken(refresh)
            })
            return resolve(fetchFile)
          })
        })
        .then((response)=>{
          if(response && formData) {
            const fullName = combineNames(formData?.firstName, formData?.lastName)
            const payload = {
              "template": "Worldify-Welcome-Email",
              "send_to": `${formData.email}`,
              "contents": {
                "name": `${fullName}`,
                "document_link": `${response.awsFilePath}`
              }
            }
            sendEmail(payload)
            .then((response) => {
              if(response?.status == 200) {
                setEmailStatus('success')
                
                if(isEmailValid(formData?.email, rejectedDomains)){
                  sendToHubspot(formData, role)
                  .then((response) => {
                    if (response?.headers['rate-limit-token'] && response?.headers['rate-limit-refresh-token']) {
                      sso(response?.headers['rate-limit-token'], response?.headers['rate-limit-refresh-token']);
                    }
                  })
                  .catch((error) => {
                    refreshLimitToken(refresh)
                  })
                }
              }else{
                setEmailStatus('fail')
              }
              if (response?.headers['rate-limit-token'] && response?.headers['rate-limit-refresh-token']) {
                sso(response?.headers['rate-limit-token'], response?.headers['rate-limit-refresh-token']);
              }
              setLoading(false)
              onClick(true)
            })
            .catch((error) => {
              setLoading(false)
              refreshLimitToken(refresh)
              onClick(true)
              setEmailStatus('fail')
            })
          }
        })
        return fileObj
      })

    const handleExport = async () => {
        try {
          const blob = await handlePDF(text);
          savePdf(blob, role, uId);
        } catch (error) {
          console.error("Error Generating PDF:", error);
        }
    };

    const handleHovering = (isHovered) => {
      setHoveredBuildMii(isHovered);
    };

    return(
        <>
            <button
                className={`${
                disabled ? "bg-gray-300" : hoveredBuildMii ? "bg-blue-700" : "bg-gradient-to-r from-themeColor-200 to-themeColor-100"
                } text-white-700 font-bold py-2 px-4 rounded-full`}
                disabled={disabled || loading} // Disable the button while loading
                onMouseEnter={() => handleHovering(true)}
                onMouseLeave={() => handleHovering(false)}
                onClick={handleExport}
            >
                {loading ? (
                <div className="border-[4px] border-gray-700 border-t-blue-600 animate-spin h-[2rem] w-[2rem] rounded-[50%]" />
                ) : (
                "Send"
                )}
            </button>
        </>
    )
}

export default JsPDFExporter;